/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxGamesLibWebPlatformDataOptionsSteamOptions
 */
export interface FxGamesLibWebPlatformDataOptionsSteamOptions {
    /**
     * 
     * @type {number}
     * @memberof FxGamesLibWebPlatformDataOptionsSteamOptions
     */
    SteamId: number;
}

/**
 * Check if a given object implements the FxGamesLibWebPlatformDataOptionsSteamOptions interface.
 */
export function instanceOfFxGamesLibWebPlatformDataOptionsSteamOptions(value: object): value is FxGamesLibWebPlatformDataOptionsSteamOptions {
    if (!('SteamId' in value) || value['SteamId'] === undefined) return false;
    return true;
}

export function FxGamesLibWebPlatformDataOptionsSteamOptionsFromJSON(json: any): FxGamesLibWebPlatformDataOptionsSteamOptions {
    return FxGamesLibWebPlatformDataOptionsSteamOptionsFromJSONTyped(json, false);
}

export function FxGamesLibWebPlatformDataOptionsSteamOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxGamesLibWebPlatformDataOptionsSteamOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'SteamId': json['SteamId'],
    };
}

export function FxGamesLibWebPlatformDataOptionsSteamOptionsToJSON(json: any): FxGamesLibWebPlatformDataOptionsSteamOptions {
    return FxGamesLibWebPlatformDataOptionsSteamOptionsToJSONTyped(json, false);
}

export function FxGamesLibWebPlatformDataOptionsSteamOptionsToJSONTyped(value?: FxGamesLibWebPlatformDataOptionsSteamOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'SteamId': value['SteamId'],
    };
}

